const Aside = () => (
  <aside>Lets do some math!</aside>
);

export default Aside;
